<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark ">
    <div class="container-md">
    <a class="navbar-brand">Yapılacaklar listesi</a>
    <div class="row">
      <div class="col-9">
      <form class="form-inline">
        <div class="d-flex ">
        <input
          class="form-control-sm mr-sm-2"
          type="search"
          placeholder="Bir task arayın"
          aria-label="Search"
          v-model="searchItem"
        />
        <a
          class="btn btn-sm btn-outline-success  ml-2 "
          @click.prevent="ara(searchItem)"
        >
          Ara
        </a>

        <!-- <a class="btn btn-outline-info my-2 my-sm-0 ml-2"  @click.prevent="aramayibirak()">
          Tam listeye dön
        </a> -->
        </div>
      </form>
      </div>
      <div class="col-3">
                        <a class="btn btn-sm btn-outline-danger" @click="cik()"> Çıkış </a>

      </div>
    </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "navbar",
  data() {
    return {
      searchItem: "",
    };
  },
  methods: {
    cik() {
      localStorage.removeItem("name");
      return this.$router.push({ name: "login" });
    },
    ara(searchItem) {
      this.$store.dispatch("searchTodo", searchItem);
    },
    // aramayibirak(){
    //     this.searchItem = '';
    //     this.$store.dispatch("searchTodo",this.searchItem);
    // }
  },
};
</script>

<style></style>
